import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppserverConfigurationService } from './../../../shared/services/appserver-configuration/appserver-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityKeyGuard  {

  constructor(
    private appserverConfigurationService: AppserverConfigurationService,
    private router: Router){
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isSecurityEnabled$ = this.appserverConfigurationService.isSecurityEnabled();

    const sub = isSecurityEnabled$.subscribe(
      {
        next: isEnabled => {
          if(!isEnabled){
            if (state.url.includes('customers')) {
              this.router.navigate(['customers/incorrect-configuration'], {queryParams: {id: 'disabled-security-customer'}});
            }else {
              this.router.navigate(['incorrect-configuration'], {queryParams: {id: 'disabled-security'}});
            }
          }
        },
        complete: () => {
          if (state.url.includes('carga')) {
            this.appserverConfigurationService.availableAPIAppserverConfig.next(undefined);
          }
          sub.unsubscribe();
        }
      });

    return isSecurityEnabled$;
  }
}
